import { useState } from "react";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { MdKeyboardArrowLeft } from "react-icons/md";
import "./Search.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setRunningData } from "../../../../AsianExchangeSrc/redux/slices/fullmarketSlice";

const Search = ({ closeSearch }) => {
    const dispatch = useDispatch();
  const [query, setQuery] = useState("");

  const { matches: cricketMatches } = useSelector(
    (state) => state.matches.cricket
  );
  const { matches: soccerMatches } = useSelector(
    (state) => state.matches.soccer
  );
  const { matches: tennisMatches } = useSelector(
    (state) => state.matches.tennis
  );

  const filterInplayMatches = (matches) => {
    return matches?.data || [];
  };

  const filteredCricketMatches = filterInplayMatches(cricketMatches);
  const filteredSoccerMatches = filterInplayMatches(soccerMatches);
  const filteredTennisMatches = filterInplayMatches(tennisMatches);

  const allMatches = [
    ...(filteredCricketMatches || []),
    ...(filteredSoccerMatches || []),
    ...(filteredTennisMatches || []),
  ];
  console.log({ allMatches });

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const searchResults = allMatches.filter((match) =>
    match?.eventName?.toLowerCase().includes(query.toLowerCase())
  );

  const handleMarket = (runningData) => {
    dispatch(setRunningData(runningData));
  };

  return (
    <div className="mobile-search-wrap">
      <div className="search-header">
        <MdKeyboardArrowLeft className="icon back-icon" onClick={closeSearch} />
        <input
          type="text"
          className="input-box"
          placeholder="Search by keyword"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <div className="mobile-search-box">
          <IoMdClose className="icon close-icon" onClick={() => setQuery("")} />
          <IoMdSearch className="icon-search-icon" />
        </div>
      </div>

      {query && (
        <div className="search-dropdown">
          {searchResults.length > 0 ? (
            searchResults.map((match) => (
              <Link
                to={`/fullMarket?eventType=4&eventId=${match?.eventId}&marketId=${match?.marketId}&joinedMarketIds=${match?.joinedMarketIds}&competitionId=${match?.competitionId}&bm=${match?.bm}&fancy=${match?.fancy}&pc=${match?.pc}&eventName=${match.eventName}`}
                onClick={() => handleMarket(match?.matchRunners)}
                key={match.eventId}
                className="search-item"
              >
                <span className="match-time">
                  {formatTime(match?.openDate) || "00:00"}
                </span>
                <span className="match-name">{match?.eventName}</span>
              </Link>
            ))
          ) : (
            <div className="search-item">No matches found.</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;
